import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Desktop from './Desktop';
import Mobile from './Mobile';

const SnackBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return isMobile ? <Mobile /> : <Desktop />;
};

export default SnackBar;
